// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'plus-line-below';

export const Component = () => (
  <path d='M25 24v1H0v-1h25zM12.848 6h-.957v5.89H6v.958h5.89v5.891h.958v-5.89h5.891v-.958h-5.89V6z' />
);

export const viewBox = '0 0 25 25';
